import createIcon from '../../createIcon';

/**
 * @component @name ElectricMoped
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEMxOSAyLjkgMTguMSAyIDE3IDJIMTRWNEgxN1Y2LjY1TDEzLjUyIDExSDEwVjZINkMzLjc5IDYgMiA3Ljc5IDIgMTBWMTNINEM0IDE0LjY2IDUuMzQgMTYgNyAxNkM4LjY2IDE2IDEwIDE0LjY2IDEwIDEzSDE0LjQ4TDE5IDcuMzVWNFpNNyAxNEM2LjQ1IDE0IDYgMTMuNTUgNiAxM0g4QzggMTMuNTUgNy41NSAxNCA3IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDNINVY1SDEwVjNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkgMTBDMTcuMzQgMTAgMTYgMTEuMzQgMTYgMTNDMTYgMTQuNjYgMTcuMzQgMTYgMTkgMTZDMjAuNjYgMTYgMjIgMTQuNjYgMjIgMTNDMjIgMTEuMzQgMjAuNjYgMTAgMTkgMTBaTTE5IDE0QzE4LjQ1IDE0IDE4IDEzLjU1IDE4IDEzQzE4IDEyLjQ1IDE4LjQ1IDEyIDE5IDEyQzE5LjU1IDEyIDIwIDEyLjQ1IDIwIDEzQzIwIDEzLjU1IDE5LjU1IDE0IDE5IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcgMTlIMTFWMTdMMTcgMjBIMTNWMjJMNyAxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElectricMoped = createIcon('ElectricMoped', [
  [
    'path',
    {
      d: 'M19 4C19 2.9 18.1 2 17 2H14V4H17V6.65L13.52 11H10V6H6C3.79 6 2 7.79 2 10V13H4C4 14.66 5.34 16 7 16C8.66 16 10 14.66 10 13H14.48L19 7.35V4ZM7 14C6.45 14 6 13.55 6 13H8C8 13.55 7.55 14 7 14Z',
      key: 'dx8aia',
    },
  ],
  ['path', { d: 'M10 3H5V5H10V3Z', key: 'hqgg1f' }],
  [
    'path',
    {
      d: 'M19 10C17.34 10 16 11.34 16 13C16 14.66 17.34 16 19 16C20.66 16 22 14.66 22 13C22 11.34 20.66 10 19 10ZM19 14C18.45 14 18 13.55 18 13C18 12.45 18.45 12 19 12C19.55 12 20 12.45 20 13C20 13.55 19.55 14 19 14Z',
      key: '1hom14',
    },
  ],
  ['path', { d: 'M7 19H11V17L17 20H13V22L7 19Z', key: '1m5ql3' }],
]);

export default ElectricMoped;
